import * as React from 'react';
import WeatherSunOutlined from './weather-sun-outlined';
import WeatherSunFilled from './weather-sun-filled';
import type { IconCombinedProps } from './types';
const WeatherSunCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <WeatherSunFilled ref={ref} {...rest} />;
  }
  return <WeatherSunOutlined ref={ref} {...rest} />;
});
export default WeatherSunCombined;